"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm2.813-4.884c2.69-1.27 3.534-3.617 3.723-4.531-.983 1.007-2.071 2.028-2.803 1.321 0 0-.04-3.772-.04-5.318 0-2.08 1.972-3.63 1.972-3.63-1.085.193-2.387.58-3.77 1.936a5.053 5.053 0 0 0-.354.39c-.592-.454-1.36-.318-1.36-.318.415.228.829.892.829 1.441v5.402s-.905.796-1.602.796a.986.986 0 0 1-.806-.409 1.06 1.06 0 0 1-.136-.234V8.289c-.206.17-.902.31-.902-.846 0-.719.517-1.575 1.439-2.1A6.79 6.79 0 0 0 7.584 6.92a6.695 6.695 0 0 0-2.317 5.131s.674-2.106 1.518-2.3a.816.816 0 0 1 1.023.816v4.944c0 .502-.323.611-.621.606a2.626 2.626 0 0 1-.596-.113 6.726 6.726 0 0 0 5.32 2.729l1.822-1.832 1.08 1.215z" }), "Unreal");
//# sourceMappingURL=UnrealCircle.js.map